// extracted by mini-css-extract-plugin
export default {"container":"_3hE-L___Input-module__container","label":"_31jig___Input-module__label","input":"_3AfJw___Input-module__input"};